<template>
    <Modal
            v-model="show"
            title="销售明细"
            :width="1200"
            :closable="false"
            footer-hide
        >
            <Card :padding="0" :bordered="false" :dis-hover="true">
                <!-- 工具栏 -->
                <Row class="tool-bar-row">
                    <Col span="24">
                        <div class="modal-tool-bar">
                            <div class="left-bar">
                                <span class="title">定金明细列表</span>
                                <span v-if="summaryInfo" class="summary-info">
                                    收定金: {{ formatMoney(summaryInfo.totalInflow) }} |
                                    退定金: {{ formatMoney(summaryInfo.totalConsume) }}
                                </span>
                            </div>
                            <div class="right-bar">
                                <Button
                                    type="info"
                                    size="small"
                                    class="action-btn"
                                    icon="ios-send"
                                    @click="onDetailExport"
                                >
                                    导出
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>


                <Row :gutter="16">
                    <Col span="24">
                        <stand-pagination-table
                            :columns="tableColumns"
                            :data="mainTable.data"
                            :loading="mainTable.loading"
                            :table-search="mainTable.tableSearch"
                            :table-load-event="loadTableData"
                            :autoHeight="true"
                            summaryLabelField = "depositBillRecordCode"
                            :summaryFields="['inflow', 'consume']"
                            :totalSummaryFieldDatas="mainTable.sumData"
                            :showPage="true"
                        />
                    </Col>
                </Row>
            </Card>
            <div slot="header" class="div-header">
                <Button class="btn-font" type="text" @click="cancel">✕</Button>
            </div>
        </Modal>
</template>

<script>
import search from "@/libs/search";
import StandPaginationTable from "@/components/pagination-table/pagination-table.vue";
import { getSeedFarmDepositStatSqlDetail } from "@/api/modules/sale-management/sale-stat";
import { dateTimeRender, dateRender } from "@/libs/tableRowTimeRender";
import { numberToFixed } from "@/components/number-input/display-format";
import { DOWNLOAD_SERVER } from "@/api/modules/files";
import { number2ThousandsFormat } from "@/components/number-input/display-format";
export default {
    name: "SeedfarmDepositStatModal",
    components: {
        StandPaginationTable
    },
    data() {
        return {
            show: false,
            seedfarmUuid: "",
            selectDates: [],
            groupBy: "seedFarm",
            mainTable: {
                data: [],
                sumData: [],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    computed: {
        summaryInfo() {
            if (!this.mainTable.sumData || this.mainTable.sumData.length === 0) {
                return null;
            }

            const sumItem = this.mainTable.sumData[0];
            return {
                totalInflow: sumItem.inflow || 0,
                totalConsume: sumItem.consume || 0
            };
        },
        tableColumns() {
            return [
                {
                    title: "定金单编号",
                    key: "depositBillRecordCode",
                    width: 150,
                    align: "center",
                    excel: true
                },
                {
                    title: "单据编号",
                    key: "relateCode",
                    width: 100,
                    align: "center",
                    excel: true
                },
                {
                    title: "苗场编号",
                    key: "seedFarmCode",
                    width: 60,
                    align: "center",
                    excel: true
                },
                {
                    title: "苗场名称",
                    key: "seedFarmName",
                    width: 100,
                    align: "center",
                    excel: true
                },
                {
                    title: "客户账号",
                    key: "userName",
                    width: 80,
                    align: "center",
                    excel: true
                },
                {
                    title: "客户名称",
                    key: "userPersonName",
                    width: 60,
                    align: "center",
                    excel: true
                },
                {
                    title: "收定金",
                    key: "inflow",
                    width: 80,
                    align: "center",
                    render: (h, params) => {
                        const value = params.row.inflow;
                        return h('span', value);
                    },
                    excel: true
                },
                {
                    title: "退定金",
                    key: "consume",
                    width: 80,
                    align: "center",
                    render: (h, params) => {
                        const value = params.row.consume;
                        return h('span', value);
                    },
                    excel: true
                },
                {
                    title: "支付状态",
                    key: "depositBillRecordPaidStatus",
                    width: 80,
                    align: "center",
                    excel: true
                },
                {
                    title: "定单状态",
                    key: "depositBillRecordOrderStatus",
                    width: 80,
                    align: "center",
                    excel: true
                },
                {
                    title: "发货状态",
                    key: "shipStatus",
                    width: 80,
                    align: "center",
                    excel: true
                },
                {
                    title: "发货单状态",
                    key: "shipStatus",
                    width: 80,
                    align: "center",
                    render: (h, params) => {
                        const value = params.row.preSaleDeliveryRecordStatus;
                        let text = '';
                        switch (value) {
                            case 0:
                                text = '未发货';
                                break;
                            case 1:
                                text = '已发货';
                                break;
                            case 2:
                                text = '关闭';
                                break;
                            case 3:
                                text = '撤销';
                                break;
                        }
                        return h('span', text);
                    },
                    excel: true
                },
                {
                    title: "操作时间",
                    key: "cTime",
                    width: 130,
                    align: "center",
                    render: (h, params) => dateTimeRender(h, params.row.cTime),
                    excel: true
                }
            ];
        }
    },
    methods: {
        number2ThousandsFormat,
        cancel() {
            this.resetTableState();
            this.show = false;
        },
        /**
         * 格式化金额显示
         */
        formatMoney(value) {
            return number2ThousandsFormat(value || 0, 2, "￥");
        },
        showModal(uuid, dates, groupBy) {
            this.seedfarmUuid = uuid;
            this.selectDates = dates;
            this.groupBy = groupBy;
            this.loadTableData();
        },
        resetTableState() {
            this.mainTable.tableSearch.limit.conditions.pageStart = 1;
            this.mainTable.tableSearch.limit.conditions.pageLength = 10;
        },
        loadTableData() {
            this.setDateRangeFilter();
            this.setSeedFarmUuid();
            this.show = true;
            this.mainTable.loading = true;

            getSeedFarmDepositStatSqlDetail(this.mainTable.tableSearch)
                .then(this.handleTableDataResponse)
                .catch(this.handleTableDataError)
                .finally(() => {
                    this.mainTable.loading = false;
                });
        },
        handleTableDataResponse(res) {
            if (res.code === 0) {
                this.mainTable.data = res.data.list;
                this.mainTable.sumData = res.data.sum;
                search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
            } else {
                this.$Message.error(res.message || '数据加载失败');
            }
        },
        handleTableDataError(error) {
            console.error('加载种子农场押金统计数据失败:', error);
            this.$Message.error('网络请求失败，请稍后重试');
        },
        onDetailExport() {
            const exportSearch = this.prepareExportSearch();

            this.mainTable.loading = true;
            getSeedFarmDepositStatSqlDetail(exportSearch)
                .then(this.handleExportResponse)
                .catch(this.handleExportError)
                .finally(() => {
                    this.mainTable.loading = false;
                });
        },
        prepareExportSearch() {
            const exportSearch = search.deepClone(this.mainTable.tableSearch);

            exportSearch.limit.enable = false;
            exportSearch.excelExport.enable = true;
            exportSearch.excelExport.columns2 = this.tableColumns
                .filter((col) => col.excel)
                .map((col) => ({
                    key: col.key,
                    title: col.title
                }));

            return exportSearch;
        },
        handleExportResponse(res) {
            if (res.code === 0 && res.data.exportFileName2) {
                const url = DOWNLOAD_SERVER + res.data.exportFileName2;
                this.$downLoadFile(url);
                this.$Message.success('导出成功');
            } else {
                this.$Message.error(res.message || '导出失败');
            }
        },
        handleExportError(error) {
            console.error('导出统计明细失败:', error);
            this.$Message.error('导出失败，请稍后重试');
        },
        
        setSeedFarmUuid(){
            const farmUuid=this.seedfarmUuid;
            if (!farmUuid) {
                return;
            }
            search.globalAddFilterConditionKey(this.mainTable.tableSearch, "seedFarmUuid", "eq", farmUuid, true);
        },
        setDateRangeFilter() {
            if (!this.selectDates || this.selectDates.length < 2) {
                return;
            }
            const [startDate, endDate] = this.selectDates;
            search.globalAddFilterConditionKey(this.mainTable.tableSearch, "beginDate", "eq", startDate, true);
            search.globalAddFilterConditionKey(this.mainTable.tableSearch, "endDate", "eq", endDate, true);
        }
    }
};
</script>

<style scoped>
.modal-tool-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
}
.modal-tool-bar .title {
    font-size: 15px;
    font-weight: 600;
    color: #2d8cf0;
}

.summary-info {
    font-size: 13px;
    color: #666;
    background: white;
    padding: 4px 12px;
    border-radius: 12px;
    border: 1px solid #e9ecef;
}

.modal-tool-bar .right-bar {
    display: flex;
    gap: 12px;
}

.action-btn {
    min-width: 70px;
    font-weight: 500;
}
</style>